import React from 'react';

const PeriodScaleLegends = ({first,firstMid, mid, midLast, last}) => {
    return (
        <table className="table mb-3 mt-6 ml-[10px] text-left">
            <thead>
                <tr>
                    <th className="pr-4">Legenda de períodos</th>
                    <th>Legenda de escala</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="align-top">
                        <ul className="flex flex-row flex-wrap list-none p-0 ml-10 gap-2">
                            <li className="flex items-center gap-2 mb-1">
                                <span className="inline-block w-7.5 h-3.75 bg-[#d7ebff] rounded-sm"></span> Madrugada
                            </li>
                            <li className="flex items-center gap-2 mb-1">
                                <span className="inline-block w-7.5 h-3.75 bg-[#9dceff] rounded-sm"></span> Manhã
                            </li>
                            <li className="flex items-center gap-2 mb-1">
                                <span className="inline-block  w-7.5 h-3.75 bg-[#62b0ff] rounded-sm"></span> Tarde
                            </li>
                            <li className="flex items-center gap-2 mb-1">
                                <span className="inline-block  w-7.5 h-3.75 bg-[#358de5] rounded-sm"></span> Noite
                            </li>
                        </ul>
                    </td>

                    <td className="align-top">
                        <ul className="flex flex-row flex-wrap list-none p-0 ml-10 gap-2">
                            <li className="flex items-center gap-2 mb-1">
                                <span className="inline-block  w-7.5 h-3.75 bg-[#FFF9C4] rounded-sm border border-gray-200"></span> {first} - {firstMid}
                            </li>
                            <li className="flex items-center gap-2 mb-1">
                                <span className="inline-block  w-7.5 h-3.75 bg-[#FFEB3B] rounded-sm border border-gray-200"></span> {firstMid} - {mid}
                            </li>
                            <li className="flex items-center gap-2 mb-1">
                                <span className="inline-block  w-7.5 h-3.75 bg-[#FF9800] rounded-sm border border-gray-200"></span> {mid} - {midLast}
                            </li>
                            <li className="flex items-center gap-2 mb-1">
                                <span className="inline-block  w-7.5 h-3.75 bg-[#F44336] rounded-sm border border-gray-200"></span> {midLast} - {last}
                            </li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default PeriodScaleLegends;
